export const SEARCH_CUSTOMERS = "SEARCH_CUSTOMERS";
